export default "__VITE_PUBLIC_ASSET__ee406153__"